import {Button, ButtonType} from "@renta-apps/athenaeum-react-components";
import ExpandableMenu from "@/components/ExpandableMenu/ExpandableMenu";
import Localizer from "@/localization/Localizer";
import React from "react";
import styles from "./ReturnedMassProductHeader.module.scss";
import rentaToolsStyles from "@/pages/RentaTools.module.scss";
import {Utility} from "@renta-apps/athenaeum-toolkit";
import {ReturnedMassProductProps} from "@/components/ReturnedMassProductHeader/ReturnedMassProduct.types";
import ToolsPageHeader from "@/components/ToolsPageHeader/ToolsPageHeader";

const ReturnedMassProductHeader = ({extendedViewOnChange, onFilterClick, itemsCount, isEmpty} : ReturnedMassProductProps) => {

    const getIconName = (): string => {
         return isEmpty ? "far filter" : "fas filter";
    };
    
    return (
        <div className={Utility.css(rentaToolsStyles.stickyDeviceListHeader, styles.stickyHeader)}>
            <div className={styles.headerContainer}>
                <ToolsPageHeader stickyHeader
                                 title={Localizer.returnedDevicesPageTitle.toUpperCase()}
                />
                <span className={styles.massProductCounter}>{Localizer.massProductListUnInspectedCount.format(itemsCount)}</span>
                <div className={styles.actionContainer}>
                    <div>
                        <ExpandableMenu
                            onClick={() => extendedViewOnChange()}
                            buttonDescription={Localizer.genericExpandedMenu}
                            buttonState={false}
                        />
                    </div>
                    <div>
                        <Button
                            id="device_list_filter"
                            small
                            type={ButtonType.Blue}
                            icon={{name: getIconName(), className: styles.filterIcon}}
                            className={styles.filterButton}
                            onClick={async () => onFilterClick()}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReturnedMassProductHeader;